import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { IUser } from 'src/app/core/models/user.model';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ClientService } from 'src/app/core/services/client.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { ApplicationService } from 'src/app/core/services/application.service';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/core/services/auth.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Role } from 'src/app/core/models/role';
import {
  IBackgroundFile,
  IBackgroundModel,
} from 'src/app/core/models/background.model';
import { BackgroundService } from 'src/app/core/services/background.service';
import { PresetService } from 'src/app/core/services/preset.service';
import { IPreset } from 'src/app/core/models/preset.model';
import { Observable, forkJoin } from 'rxjs';
import { IFeatureModel } from 'src/app/core/models/feature.model';
import { map } from 'rxjs/operators';
import { FeatureService } from 'src/app/core/services/feature.service';
import {
  bgTypeOptions,
  blurOptions,
  cropOptions,
  logoPositionOptions,
  interiorCropOptions,
  cameraLibelaSensitivity,
  shadowType,
} from 'src/app/core/const/settings';
import { IClientModel } from 'src/app/core/models/application.model';
import { BackgroundSetupComponent } from '../../modals/background-setup/background-setup.component';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/core/services/user.service';
import { sharedDataService } from 'src/app/core/services/sharedData.service';
import { UtilService } from 'src/app/core/services/util/util.service';
import { IImagesModel } from 'src/app/core/models/image.model';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { AddUserComponent } from '../../modals/add-user/add-user.component';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css'],
})
export class ClientComponent implements OnInit {
  @Input() clientData: IClientModel;
  @Input() customersData: any | {};
  @Input() secondProfilesOnThePage: boolean = false;
  @Input() darkMode: boolean = false;
  @Input() applicationsAll;
  @Input() applications;

  page = 1;
  perPage = 15;
  @Output() reloadClients = new EventEmitter<boolean>();

  @Output() credit = new EventEmitter();

  @ViewChild('dialogBgSetup') private dialogBgSetup: BackgroundSetupComponent;
  @ViewChild('dialogDefaultPlate') public dialogDefaultPlate: TemplateRef<any>;
  @ViewChild('dialogAddUser') private dialogAddUser: AddUserComponent;
  private modalDeleteFile: NgbModalRef;

  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal',
  };

  applicationLogos: IImagesModel[];
  applicationBgs: IImagesModel[];
  fileToUpload: any;
  fileToDelete: IImagesModel;
  progress: number;
  uploading = false;
  toggleAddLogo = false;
  toggleAddBackground = false;

  isUploading = false;

  toggleAddClientCredit = false;
  currentUser;

  presetsList: any = [];

  featuresNames: any;

  customer: any;

  licensePlates;
  licensePlateModal;
  toggleAddLicensePlate = false;
  previewImage = null;
  licensePlateFile = null;
  logoFile = null;

  clientFeatures;
  toggleFeaturePrice = false;

  cropOptions = cropOptions;
  bgTypeOptions = bgTypeOptions;
  cameraLibelaSensitivity = cameraLibelaSensitivity;
  logoPositionOptions = logoPositionOptions;
  blurOptions = blurOptions;
  interiorCropOptions = interiorCropOptions;
  shadowType = shadowType;

  newBackgrounds: IBackgroundModel[];
  allNewBackgrounds: IBackgroundModel[];
  BgToDelete: any;
  backgroundFiles: IBackgroundFile[] = [];
  backgroundSearch: IBackgroundModel[];
  showMyContainer = false;
  allBackgroundFiles: IBackgroundFile[] = [];

  users: IUser[];
  clientID: string;

  isLoading: boolean = false;

  searchParam = '';
  usersDataSearch: IUser[] = [];

  filterOptions = [
    { label: '3+ Days ago', value: 3 },
    { label: '5+ Days ago', value: 5 },
    { label: '10+ Days ago', value: 10 },
  ];
  selectedFilter: number | null = null;

  constructor(
    private customerService: CustomerService,
    private userService: UserService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private sharedData: sharedDataService,
    private authService: AuthService,
    private applicationService: ApplicationService,
    private router: Router,
    private route: ActivatedRoute,
    private backgroundService: BackgroundService,
    private presetService: PresetService,
    private clientService: ClientService,
    private featureService: FeatureService,
    private util: UtilService
  ) {}

  ngOnInit(): void {
    this.translate
      .get([
        'features.cutting',
        'features.licensePlateImage',
        'features.reflectiveFloor',
        'features.polishing',
        'features.rimPolishing',
        'features.licensePlateBlur',
        'features.refectiveFloorFull',
        'features.removeReflections',
        'features.platform_360',
      ])
      .subscribe((values) => {
        this.featuresNames = values;
        this.featuresNames = Object.entries(values);
      });
    this.isLoading = true;
    this.translate
      .get(['global.loading', 'user.selectPreset', 'user.selectBackgrounds'])
      .subscribe((values) => {
        const translation = Object.keys(values).map((key) => values[key]);
      });

    this.route.queryParams.subscribe((queryParams: Params) => {
      this.page = queryParams.page ? queryParams.page : 1;
      this.clientID = queryParams.clientId ? queryParams.clientId : null;
      this.searchParam = queryParams.searchParam ? queryParams.searchParam : '';
      this.reloadClients.emit();
    });

    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });

    this.initializeBackgroundsAndPresets();
    this.loadLicensePlates();
    this.getCustomerById();
    this.loadClientSettings();
    this.loadUsers();
    this.loadVehicleTypes();

    forkJoin({
      clientFeatures: this.loadClientFeaturesPrice(),
      features: this.loadAllFeatures(),
      logos: this.loadApplicationLogos(),
      oldBackgrounds: this.loadApplicationOldBackgrounds(),
    }).subscribe((res) => {
      this.clientFeatures = res.clientFeatures;
      this.features = res.features;
      this.applicationLogos = res.logos;
      this.applicationBgs = res.oldBackgrounds;
      this.isLoading = false;
    });

    console.log(this.applications)
  }

  getCustomer(customerId: string): IUser {
    let customer = null;
    let found = false;
    this.customersData.forEach((cust) => {
      if (cust.id === customerId) {
        customer = cust;
        found = true;
      }
    });
    if (!found) {
      customer = {};
      customer.name = 'customer not found';
    }

    return customer;
  }

  getCustomerById() {
    this.customerService.get(this.clientData.customerId).subscribe((res) => {
      this.customer = res;
    });
  }

  toggleChangeCustomer = false;

  showCustomers = false;
  searchCustomersParam = '';
  customersSearch = [];
  selectedCustomer = null;
  onChangeCustomer() {
    this.toggleChangeCustomer = true;
    console.log('ili ovooo')
    this.customerService.getAll().subscribe(
      (res) => {
        this.customersData = res;
      },
      (err) => {}
    );
  }

  openCustomers() {
    this.showCustomers = !this.showCustomers;
    this.searchCustomersParam = '';
    this.customersSearch = this.customersData;
  }

  applyCustomerFilter() {
    this.customersSearch = [];

    this.customersSearch = this.customersData.filter(
      (customer) =>
        customer.name
          .toLowerCase()
          .indexOf(this.searchCustomersParam.toLowerCase()) !== -1
    );
  }

  selectCustomer(customer) {
    this.selectedCustomer = customer;
  }

  onCloseCustomer() {
    this.toggleChangeCustomer = false;
    this.selectedCustomer = null;
  }

  moveClient() {
    if (!this.selectedCustomer) {
      return;
    }

    let body = {
      toCustomerId: this.selectedCustomer.id,
    };

    this.clientService.changeCustomer(this.clientData.id, body).subscribe(
      (res) => {
        this.toastr.success('Client transfered.');

        this.loadClient();

        this.toggleChangeCustomer = false;
      },
      (err) => {
        this.toggleChangeCustomer = false;
        this.toastr.error(err.error.description);
      }
    );
  }

  modalDeleteApp;
  showDialogDeleteApp(content) {
    this.modalDeleteApp = this.modalService.open(content, this.dialogOptions);
  }

  deleteApp() {
    this.applicationService.deleteApplication(this.clientData.id).subscribe(
      (response) => {
        this.modalDeleteApp.close();
        this.toastr.success('client deleted.');
        if (this.clientData.credits) {
          this.onChangeCredit(-this.clientData.credits);
        }
        if (this.currentUser.role.name === 'customer' && this.clientData.credits) {
          this.setClientCredit(-this.clientData.credits);
        }
        this.reloadClients.emit(true);
        // this.loadClients(this.customerId);
        this.clientData = null;
        this.sharedData.appId = null;
      },
      (error) => {
        this.toastr.error(error.message);
        this.modalDeleteApp.close();
      }
    );
  }

  loadApplicationLogos(): Observable<IImagesModel[]> {
    return this.applicationService.getApplicationFiles(
      this.clientData.id,
      'logo'
    );
  }

  showDialogDeleteFile(content, file: IImagesModel) {
    this.fileToDelete = file;
    this.modalDeleteFile = this.modalService.open(content, this.dialogOptions);
    this.modalDeleteFile.result.then(
      (result) => {},
      (reason) => {}
    );
  }

  deleteFile() {
    if (this.fileToDelete == null) {
      this.translate.get('settings.nothingToDelete').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }
    this.applicationService
      .deleteFile(this.clientData.id, this.fileToDelete.fileId)
      .subscribe(
        (response) => {
          this.toastr.success('File deleted');
          this.loadApplicationLogos().subscribe((res) => {
            this.applicationLogos = res;
          });
          this.modalDeleteFile.close();
        },
        (error) => {
          this.toastr.error(error.message);
          this.modalDeleteFile.close();
        }
      );
  }

  getFiles(event) {
    this.fileToUpload = event.target.files[0];
  }

  uploadLogo() {
    if(this.fileToUpload === null) {
      this.translate.get('errors.pleaseUploadFile').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }
    const formData: FormData = new FormData();
    formData.append('image', this.fileToUpload, this.fileToUpload.name);
    this.progress = 0;
    this.isUploading = true;
    this.isLoading = true;
    // this.modalAddLogo.close();
    this.applicationService
      .addFile(formData, this.clientData.id, 'logo')
      .subscribe(
        (res) => {
          // progress
          if (res.type === HttpEventType.UploadProgress) {
            this.progress = Math.round((100 * res.loaded) / res.total);
            console.log(`Uploaded! ${this.progress}%`);
          }
          // finished
          if (res instanceof HttpResponse) {
            this.toastr.success('File uploaded');
            this.progress = 0;
            this.toggleAddLogo = false;
            this.isUploading = false;
            this.isLoading = false;
            // window.location.reload()
            this.loadApplicationLogos().subscribe((res) => {
              this.applicationLogos = res;
            });
          }
        },
        (error) => {
          this.progress = 0;
          this.isLoading = false;
          this.isUploading = false;
          this.toastr.error(error.message);
        }
      );
  }

  sendClientCredit(form: NgForm) {
    if (!form.form.value.credit) {
      this.translate.get('customer.creditError').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }

    if (this.clientData.paymentType === 'prepaid') {
      if (form.form.value.credit < 1) {
        const credit = -form.form.value.credit;
        const currentCredit = this.clientData.credits
          ? +this.clientData.credits
          : 0;
        if (credit > currentCredit) {
          let text =
            currentCredit === 0
              ? 'You can not go in minus'
              : `You can enter credit up to ${currentCredit}`;

          this.toastr.error(text);
          return;
        }
      }
    }

    let body = {
      amount: form.form.value.credit,
      fromCustomerId: this.clientData.customerId,
      creditType: form.form.value.creditType || 'credits',
    };
    this.clientService.addCreditToClient(this.clientData.id, body).subscribe(
      (response) => {
        this.translate.get('customer.creditAdd').subscribe((text: string) => {
          this.toastr.success(text);
        });
        this.loadClient();

        this.toggleAddClientCredit = false;
        this.onChangeCredit(form.form.value.credit);
        this.clientData.credits += form.form.value.credit;
        if (this.currentUser.role.name === 'customer' && this.clientData.credits) {
          this.setClientCredit(body.amount);
        }

        if (this.clientSettings.useCreditsFrom === 'client') {
          this.loadUsers();
        }
      },
      (error) => {
        this.toastr.error(error.message);
        this.toggleAddClientCredit = false;
      }
    );
  }

  onChangeCredit(credit: number) {
    this.credit.emit(credit);
  }

  setClientCredit(credit: number) {
    this.currentUser.customer.credits -= credit;

    this.authService.setUser(this.currentUser);

    if (this.clientSettings.useCreditsFrom === 'client') {
      this.loadUsers();
    }
  }

  navigateToInvoices() {
    if (this.currentUser.role.name === Role.CUSTOMER) {
      this.router.navigate([
        `/customer/clients/${this.clientData.id}/invoices`,
      ]);
    } else if (this.currentUser.role.name === Role.ROOT) {
      this.router.navigate([`/root/clients/${this.clientData.id}/invoices`]);
    }
  }

  clientSettings: any = null;
  features: IFeatureModel[] = [];
  toggleChangeCreditsFrom = false;
  useCreditFrom: string;

  loadClientSettings() {
    this.clientService.getClientSettings(this.clientData.id).subscribe(
      (res) => {
        this.clientSettings = res;
        this.clientSettings.previewBackground = null;
        this.loadFeatures();
        if (this.clientSettings.defaultBackground) {
          const bg: IBackgroundModel = this.newBackgrounds.find(
            (bg: IBackgroundModel) =>
              bg.id === this.clientSettings.defaultBackground
          );

          if (bg) {
            bg.backgroundFiles.forEach((file) => {
              if (file.parameter === 'preview') {
                this.clientSettings.previewBackground = file;
              }
            });
          }
        }

        /* if (this.clientSettings.defaultLicensePlate) {
          this.licensePlates.forEach((plate) => {
            if (plate.id === this.clientSettings.defaultLicensePlate) {
              this.clientSettings.previewLicensePlate = plate;
            }
          });
        }*/
        this.initializeUserBackgrounds();
      },
      (err) => {}
    );
  }

  updateClientSettings(body) {
    this.clientService.updateClientSettings(this.clientData.id, body).subscribe(
      (res) => {
        this.toggleChangeCreditsFrom = false;
        this.clientSettings = res;

        this.features.forEach((feature) => {
          this.featuresNames.forEach((name) => {
            if (feature.name === name[0].split('.')[1]) {
              feature.displayName = name[1];
            }
          });
        });

        this.features.forEach((feature) => {
          this.isFeatureDisabled(feature);
          this.isActiveFeature(feature);
        });

        this.loadClient();
        this.loadUsers();

        if (this.clientSettings.defaultBackground) {
          const bg = this.newBackgrounds.find(
            (bg: IBackgroundModel) =>
              bg.id === this.clientSettings.defaultBackground
          );

          if (bg) {
            bg.backgroundFiles.forEach((file) => {
              if (file.parameter === 'preview') {
                this.clientSettings.previewBackground = file;
              }
            });
          }
        }

        if (this.clientSettings.defaultLicensePlate) {
          this.licensePlates.forEach((plate) => {
            if (plate.id === this.clientSettings.defaultLicensePlate) {
              this.clientSettings.previewLicensePlate = plate;
            }
          });
        }
        this.translate.get('settings.updatedMsg').subscribe((text: string) => {
          this.toastr.success(text)
        });
        this.initializeUserBackgrounds();
      },
      (err) => {}
    );
  }

  loadClient() {
    this.applicationService.getById(this.clientData.id).subscribe((res) => {
      this.clientData = res;
    });
  }

  loadAllFeatures() {
    const filterOptions = {
      excludeNames: ['createVehicle', 'decodeVin', 'carConfImport']
    }
    return this.featureService.getFeatures(filterOptions);
  }
  loadFeatures() {
    const filterOptions = {
      excludeNames: ['createVehicle', 'decodeVin', 'carConfImport']
    }
    this.featureService
      .getFeatures(filterOptions)
      .subscribe(
        (res) => {
          if (this.clientData.removeReflectionsEnabled) {
            this.features = res;
          } else {
            this.features = res.filter((f) => f.name !== 'removeReflections');
          }
          this.features.forEach((feature) => {
            this.featuresNames.forEach((name) => {
              if (feature.name === name[0].split('.')[1]) {
                feature.displayName = name[1];
              }
            });
          });
          this.features.forEach((feature) => {
            this.isFeatureDisabled(feature);
            this.isActiveFeature(feature);
          });
        },
        (err) => {}
      );
  }

  isActiveFeature(feature) {
    if (this.clientSettings.features.includes(feature.name)) {
      feature.isChecked = true;
    } else {
      feature.isChecked = false;
    }
  }

  isFeatureDisabled(feature: IFeatureModel) {
    let counter = 0;
    if (feature.dependencies) {
      feature.dependencies.forEach((dep, index) => {
        if (this.clientSettings.features.includes(dep)) {
          counter++;
        }
      });
      counter === feature.dependencies.length
        ? (feature.isDisabled = false)
        : (feature.isDisabled = true);
    }

    if (
      this.clientSettings.defaultCropType !== 'full' &&
      (feature.name === 'reflectiveFloor' ||
        feature.name === 'refectiveFloorFull')
    ) {
      feature.isDisabled = true;
    }

    if (
      (this.clientSettings.defaultCropType !== 'full' ||
        this.clientSettings.backgroundType !== 'platform' ||
        this.clientSettings.defaultBackground === null) &&
      feature.name === 'platform_360'
    ) {
      feature.isDisabled = true;
    }
  }

  showMessage(feature: IFeatureModel) {
    if (feature.isDisabled) {
      if (
        this.clientSettings.defaultCropType !== 'full' &&
        feature.name === 'reflectiveFloor'
      ) {
        return this.translate.get('errors.floorReflectionsError').subscribe((text: string) => {
          this.toastr.error(text);
        });
      }
      if (
        this.clientSettings.defaultCropType !== 'full' &&
        feature.name === 'refectiveFloorFull'
      ) {
        return this.translate.get('errors.carReflectionsError').subscribe((text: string) => {
          this.toastr.error(text);
        });
      }
      if (
        (this.clientSettings.defaultCropType !== 'full' ||
          this.clientSettings.backgroundType !== 'platform' ||
          this.clientSettings.defaultBackground === null) &&
        feature.name === 'platform_360'
      ) {
        this.translate
          .get('settings.feature360Error')
          .subscribe((text: string) => {
            this.toastr.error(text);
          });
        return;
      }
      let dependencies = [];
      feature.dependencies.forEach((dep) => {
        const feature = this.features.find((f) => f.name === dep);

        if (feature !== undefined) {
          dependencies.push(feature.displayName);
        }
      });
      this.translate.get('errors.mustEnableDependencies', { dependencies: dependencies }).subscribe((text: string) => {
        this.toastr.error(text);
      });
    }
  }

  // ---- Backgrounds

  loadCustomerBackgrounds(customerId): Observable<IBackgroundModel[]> {
    return this.backgroundService.getCustomerBackgrounds(customerId);
  }
  loadClientBackgrounds(clientId): Observable<IBackgroundModel[]> {
    return this.backgroundService.getApplicationBackgrounds(clientId);
  }

  addBackground(backgroundId) {
    this.backgroundService
      .addApplicationBackground(this.clientData.id, backgroundId)
      .subscribe(
        (res) => {
          this.toastr.success('background added.');
          this.secondProfilesOnThePage
            ? this.backgroundService.setNewBackgrounds2(res)
            : this.backgroundService.setNewBackgrounds(res);
        },
        (error) => {
          // this.uploading = false;
          this.toastr.error(error.message);
        }
      );
  }

  deleteBackground(BgToDeleteId) {
    this.backgroundService
      .deleteApplicationBackground(this.clientData.id, BgToDeleteId)
      .subscribe(
        (res) => {
          this.toastr.success('Background deleted.');
        },
        (error) => {
          this.toastr.error(error.message);
        }
      );
  }

  initializeUserBackgrounds() {
    this.backgroundService.newBackgrounds2.subscribe((bg) => {
      this.backgroundFiles = [];
      this.newBackgrounds = bg;
      if (this.clientSettings) {
        this.newBackgrounds?.forEach((background) => {
          background.allowedTypes.forEach((type) => {
            if (type == this.clientSettings.backgroundType) {
              background.backgroundFiles.forEach((file) => {
                if (file.parameter === 'preview') {
                  this.backgroundFiles = this.backgroundFiles.concat(file);
                }
              });
            }
          });
        });
      }
    });
  }

  loadApplicationOldBackgrounds(): Observable<IImagesModel[]> {
    return this.applicationService.getApplicationFiles(
      this.clientData.id,
      'background'
    );
  }

  uploadBackground() {
    const formData: FormData = new FormData();
    formData.append('image', this.fileToUpload, this.fileToUpload.name);
    this.progress = 0;
    this.isUploading = true;

    this.applicationService
      .addFile(formData, this.clientData.id, 'background')
      .subscribe(
        (res) => {
          // progress
          if (res.type === HttpEventType.UploadProgress) {
            this.progress = Math.round((100 * res.loaded) / res.total);
          }
          // finished
          if (res instanceof HttpResponse) {
            this.toastr.success('File uploaded');
            this.isUploading = false;
            this.toggleAddBackground = false;
            // window.location.reload()
            this.loadApplicationOldBackgrounds().subscribe((res) => {
              this.applicationBgs = res;
            });
          }
        },
        (error) => {
          this.uploading = false;
          this.toastr.error(error.message);
        }
      );
  }

  // ---- PRESETS

  initializePresets(presets) {
    this.presetsList = presets?.filter(
      (preset) => !preset.allowedVehicleBodyTypes.length
    );
  }
  loadPresets(): Observable<IPreset[]> {
    return this.presetService.getPresets();
  }
  loadCustomerPresets(customerId): Observable<IPreset[]> {
    return this.presetService.getCustomerPresets(customerId);
  }
  loadClientPresets(clientId): Observable<IPreset[]> {
    return this.presetService.getClientPresets(clientId);
  }

  addPreset(presetId) {
    this.presetService.addClientPreset(this.clientData.id, presetId).subscribe(
      (res) => {
        this.translate.get('user.presetAdded').subscribe((text: string) => {
          this.toastr.success(text);
        });
        this.secondProfilesOnThePage
          ? this.presetService.setSelected2Presets(res)
          : this.presetService.setSelectedPresets(res);
        this.initializePresets(res);
      },
      (error) => {
        this.toastr.error(error.message);
      }
    );
  }

  deletePreset(presetsId) {
    this.presetService
      .deleteClientPreset(this.clientData.id, presetsId)
      .subscribe(
        (res) => {
          this.translate.get('user.presetRemoved').subscribe((text: string) => {
            this.toastr.success(text);
          });
          if (
            this.clientSettings.defaultPreset &&
            this.clientSettings.defaultPreset === presetsId
          ) {
            delete this.clientSettings.defaultPreset;
          }
        },
        (error) => {
          this.toastr.error(error.message);
        }
      );
  }

  initializeBackgroundsAndPresets() {
    this.loadCustomerBackgrounds(this.clientData.customerId).subscribe(
      (res) => {
        this.secondProfilesOnThePage
          ? this.backgroundService.setAllNewBackgrounds2(res)
          : this.backgroundService.setAllNewBackgrounds(res);
      }
    );
    this.loadClientBackgrounds(this.clientData.id).subscribe((res) => {
      this.backgroundService.setNewBackgrounds2(res);
      this.initializeUserBackgrounds();
      this.secondProfilesOnThePage
        ? this.backgroundService.setNewBackgrounds2(res)
        : this.backgroundService.setNewBackgrounds(res);
    });

    this.loadCustomerPresets(this.clientData.customerId).subscribe((res) => {
      this.presetService.setAllPresets2(res);
      this.secondProfilesOnThePage
        ? this.presetService.setAllPresets2(res)
        : this.presetService.setAllPresets(res);
    });
    this.loadClientPresets(this.clientData.id).subscribe((res) => {
      this.initializePresets(res);
      this.secondProfilesOnThePage
        ? this.presetService.setSelected2Presets(res)
        : this.presetService.setSelectedPresets(res);
    });
  }

  // LICENSE PLATES
  loadLicensePlates() {
    this.clientService.getLicensePlates(this.clientData.id).subscribe(
      (res) => {
        this.licensePlates = res;
      },
      (err) => {}
    );
  }

  fileSelectorOpen() {
    const element: HTMLElement = document.getElementById(
      `logoFile`
    ) as HTMLElement;
    element.click();
  }

  getFile(event) {
    this.logoFile = event.target.files[0];
    if (!this.logoFile.type.match('image.*')) {
      return this.translate.get('errors.pleaseUploadImage').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }
    this.readURL(this.logoFile);
  }

  readURL(image) {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.previewImage = reader.result;
      },
      false
    );
    if (image) {
      reader.readAsDataURL(image);
    }
  }

  getlicensePlateFile(event) {
    this.licensePlateFile = event.target.files[0];
    this.readURL(this.licensePlateFile);
  }

  addLicensePlate(form: NgForm) {
    this.isLoading = true;
    if (!form.valid) {
      this.isLoading = false;
      return this.translate.get('errors.missingData').subscribe((text: string) => {
            this.toastr.error(text);
          });
    }
    if (!this.licensePlateFile) {
      this.isLoading = false;
      return this.translate.get('errors.pleaseUploadFile').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }

    let body = new FormData();
    body.append('name', form.form.value.name);
    body.append('file', this.licensePlateFile);

    this.clientService.addLicensePlate(this.clientData.id, body).subscribe(
      (res) => {
        this.toastr.success('Successfully added License Plate');
        this.toggleAddLicensePlate = false;
        this.loadLicensePlates();
        this.isLoading = false;
      },
      (err) => {
        this.toggleAddLicensePlate = false;
        this.isLoading = false;
      }
    );
  }

  deleteLicensePlate(plate) {
    this.clientService
      .removeLicensePlate(this.clientData.id, plate.id)
      .subscribe(
        (res) => {
          this.loadLicensePlates();
        },
        (err) => {}
      );
  }

  addFeaturePrice(form: NgForm) {
    if (!form.valid) {
      this.translate.get('errors.fillAllFields').subscribe((text: string) => {
            this.toastr.error(text);
          });
      return;
    }

    const { featureId, price } = form.form.value;

    let body = {
      featureId,
      price,
    };

    this.featureService.addPriceForClient(this.clientData.id, body).subscribe(
      (res) => {
        this.loadClientFeaturesPrice().subscribe((features) => {
          this.clientFeatures = features;
          this.toggleFeaturePrice = false;
        });
      },
      (err) => {
        this.toggleFeaturePrice = false;
      }
    );
  }

  togglePrice;
  editFeaturePrice;
  loadClientFeaturesPrice(): Observable<any> {
    return this.featureService.getClientFeatures(this.clientData.id);
  }

  onEditPrice(feature) {
    this.editFeaturePrice = feature;
    this.togglePrice = true;
  }

  editPrice(form) {
    if (!form.valid) {
      this.translate.get('errors.fillAllFields').subscribe((text: string) => {
            this.toastr.error(text);
          });
      return;
    }

    const { price } = form.form.value;

    let body = {
      price,
    };

    this.featureService
      .updatePriceForClient(this.clientData.id, this.editFeaturePrice.id, body)
      .subscribe(
        (res) => {
          this.loadClientFeaturesPrice().subscribe((features) => {
            this.clientFeatures = features;
            this.togglePrice = false;
          });
        },
        (err) => {
          this.togglePrice = false;
        }
      );
  }

  deletePrice(feature) {
    this.featureService
      .deleteClientPrice(this.clientData.id, feature.id)
      .subscribe((res) => {
        this.toastr.success('Price deleted.');
        this.loadClientFeaturesPrice().subscribe((features) => {
          this.clientFeatures = features;
        });
      });
  }

  loading: boolean = false;

  updateClient(propName: string, value: any) {
    let body = {};
    body[propName] = value;
    this.loading = true;
    this.applicationService.updateClient(this.clientData.id, body).subscribe(
      (res) => {
        this.loading = false;
        this.clientData = res;
        this.toastr.success('Updated');
      },
      (err) => {
        this.translate.get('errors.error').subscribe((text: string) => {
            this.toastr.error(text);
          });
        this.loading = false;
      }
    );
  }

  switchInteriorBg(event) {
    let status = event.target.checked;
    this.updateClient('interiorBackgroundEnabled', status);
    const cropTypeInterior = 'blur';
    let body = {
      cropTypeInterior,
    };

    this.updateClientSettings(body);
    
  }

  switchPreprocessing(event) {
    let status = event.target.checked;
    this.updateClient('preprocessingEnabled', status);
  }

  switchPostInvoice(event) {
    let status = event.target.checked;
    this.updateClient('postponedInvoiceEnabled', status);
  }

  switchDuplicateCar(event) {
    let status = event.target.checked;
    this.updateClient('duplicateVehicleEnabled', status);
  }

  changeLegacyChadow(event) {
    this.updateClient('shadowType', event.target.value);
  }

  switchRemoveReflections(event) {
    let status = event.target.checked;
    this.updateClient('removeReflectionsEnabled', status);
  }

  vehicleTypes = [];
  toggleVehicleType = false;

  loadVehicleTypes() {
    this.clientService.getVehicleTypes(this.clientData.id).subscribe(
      (res) => {
        this.vehicleTypes = res;
      },
      (err) => {}
    );
  }

  addVehicleType(form: NgForm) {
    if (!form.valid) {
      return;
    }

    let { name, label } = form.form.value;

    let body = {
      name,
      label,
    };

    this.clientService.createVehicleType(this.clientData.id, body).subscribe(
      (res) => {
        this.toastr.success('Vehicle Type added.');
        this.vehicleTypes.push(res);
        this.toggleVehicleType = false;
      },
      (err) => {}
    );
  }

  editType;
  toggleEditVehicleType = false;
  onEditType(type) {
    this.editType = type;
    this.toggleEditVehicleType = true;
  }

  editVehicleType(form) {
    if (!form.valid) {
      this.translate.get('errors.fillAllFields').subscribe((text: string) => {
            this.toastr.error(text);
          });
      return;
    }

    const { name, label } = form.form.value;

    let body = {
      name,
      label,
    };

    this.clientService
      .editVehicleType(this.clientData.id, this.editType.id, body)
      .subscribe(
        (res) => {
          this.toastr.success('Success');
          this.toggleEditVehicleType = false;
          this.clientService
            .getVehicleTypes(this.clientData.id)
            .subscribe((res) => {
              this.vehicleTypes = res;
            });
        },
        (err) => {
          this.togglePrice = false;
        }
      );
  }

  deleteVehicleType(vehicleType) {
    this.clientService
      .deleteVehicleType(this.clientData.id, vehicleType.id)
      .subscribe((res) => {
        this.toastr.success('Type deleted.');

        const foundType = this.vehicleTypes.find(
          (type) => type.id === vehicleType.id
        );

        if (foundType !== undefined) {
          if (this.vehicleTypes.indexOf(foundType) !== -1) {
            this.vehicleTypes.splice(this.vehicleTypes.indexOf(foundType), 1);
          }
        }
      });
  }

  patchCreditsNotification(event) {
    const notify = event.target.checked;
    const body = {
      creditsNotificationEnabled: notify,
    };
    this.updateClientSettings(body);
  }

  updateTreshold() {
    const body = {
      creditsNotificationThreshold:
        this.clientSettings.creditsNotificationThreshold,
    };
    this.updateClientSettings(body);
  }

  updateSettingsMode(event) {
    const mode = event.target.value;

    const body = {
      userSettingsMode: mode,
    };
    this.updateClientSettings(body);
  }

  patchInteriorCropType(event) {
    const cropTypeInterior = event.target.value;
    let body = {
      cropTypeInterior,
    };

    this.updateClientSettings(body);
  }

  async openBgSetupModal() {
    return await this.dialogBgSetup.open();
  }

  SaveBgSetup({ body, newFeatures }) {
    if (newFeatures) {
      body['features'] = [...newFeatures];
    }

    this.updateClientSettings(body);
  }

  patchLogoPosition(event) {
    const position = event.target.value;

    const body = {
      logoPosition: position,
    };
    this.updateClientSettings(body);
  }
  patchBlur(event) {
    const blur: number = +event.target.value;

    const body = {
      blurAmount: blur,
    };
    this.updateClientSettings(body);
  }
  patchPreset(event) {
    const preset = event.target.value;

    const body = {
      defaultPreset: preset,
    };
    this.updateClientSettings(body);
  }

  isUpdating = false;
  patchFeature(data) {
    if (
      data.feature.name === 'licensePlateImage' &&
      !this.clientSettings.defaultLicensePlate
    ) {
      data.event.preventDefault();
      return this.translate.get('errors.defaultLicensePlateRequired').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }

    const isChecked = data.event.target.checked;

    if (isChecked) {
      // conflicts, select one, deselect other
      if (data.feature.conflicts) {
        data.feature.conflicts.forEach((conflict) => {
          if (this.clientSettings.features.indexOf(conflict) != -1) {
            this.clientSettings.features.splice(
              this.clientSettings.features.indexOf(conflict),
              1
            );
          }
        });
      }
      const body = {
        features: [...this.clientSettings.features, data.feature.name],
      };

      if (
        data.feature.name === 'cutting' &&
        this.clientSettings.defaultCropType === 'full' &&
        this.clientSettings.backgroundType === 'platform'
      ) {
        body['features'] = [
          ...this.clientSettings.features,
          data.feature.name,
          'platform_360',
        ];
      }
      this.updateClientSettings(body);
    } else {
      if (this.clientSettings.features.indexOf(data.feature.name) != -1) {
        this.clientSettings.features.splice(
          this.clientSettings.features.indexOf(data.feature.name),
          1
        );
      }

      // if we deselect feature, all features that have
      // that feature in dependcies must also be deselected
      this.features.forEach((f) => {
        if (f.dependencies.length && f.name !== data.feature.name) {
          f.dependencies.forEach((dep, index) => {
            console.log(dep, f.isChecked);
            if (dep === data.feature.name && f.isChecked) {
              if (this.clientSettings.features.indexOf(f.name) != -1) {
                this.clientSettings.features.splice(
                  this.clientSettings.features.indexOf(f.name),
                  1
                );
              }
            }
          });
        }
      });

      if (data.feature.name === 'cutting') {
        this.toastr.info(
          'All features that depend on Segmentation feature will be switched OFF.'
        );
      }

      const body = {
        features: [...this.clientSettings.features],
      };
      this.updateClientSettings(body);
    }
  }

  openPatchLicensePlate() {
    this.licensePlateModal = this.modalService.open(
      this.dialogDefaultPlate,
      this.dialogOptions
    );
    this.licensePlateModal.result.then(
      (result) => {},
      (reason) => {}
    );
  }

  patchLicensePlate(plate) {
    let defaultLicensePlate: string;
    let body = {};

    if (plate) {
      defaultLicensePlate = plate.id;
    } else {
      defaultLicensePlate = null;
      const indexOfLicensePlateImage =
        this.clientSettings.features.indexOf('licensePlateImage');

      if (indexOfLicensePlateImage !== -1) {
        this.clientSettings.features.splice(indexOfLicensePlateImage, 1);
        this.toastr.info('Feature License Plate Image will be switched OFF.');
      }
      body['features'] = [...this.clientSettings.features];
    }
    body['defaultLicensePlate'] = defaultLicensePlate;
    this.updateClientSettings(body);
    this.licensePlateModal.close();
  }

  patchQC(event) {
    const isChecked = event.target.checked;

    const body = {
      qualityCheck: isChecked,
    };
    this.updateClientSettings(body);
  }

  patchCameraSensitivity(event) {
    const cameraLibelaSensitivity = event.target.value;

    const body = {
      cameraLibelaSensitivity,
    };

    this.updateClientSettings(body);
  }


  loadUsers() {
    this.customerService
      .getSubcustomerUsers(this.clientData.customerId, this.clientData.id)
      .subscribe((res: IUser[]) => {
        this.users = res;
        this.usersDataSearch = res;
        this.checkStatus(this.usersDataSearch);
        this.applyFilter();
      });
  }

  async openAddUserModal() {
    return await this.dialogAddUser.open();
  }

  sendUser(data) {
    const formValue = data.form.form.value;

    if (data.toggleNewClient) {
      const { nameClient, description } = formValue;

      const body = {
        name: nameClient,
        description,
      };

      this.applicationService
        .addClientAsCustomer(body, this.clientData.customerId)
        .subscribe(
          (response: IClientModel) => {
            this.reloadClients.emit();
            this.createUser(formValue, undefined, response.id);
          },
          (error) => {
            this.translate.get('errors.errorCreatingApplication').subscribe((text: string) => {
            this.toastr.error(text);
          });
          }
        );
    } else {
      this.createUser(formValue, data.clientId);
    }
  }

  createUser(form: any, clientId?: string, newClientId?: string) {
    const { fullName, email, password, type } = form;
    let additionalInvoiceInfo;
    form.additionalInvoiceInfo === ''
      ? (additionalInvoiceInfo = undefined)
      : (additionalInvoiceInfo = form.additionalInvoiceInfo);
    const body = {
      name: fullName,
      email,
      password,
      type,
      customerId: this.clientData.customerId,
      additionalInvoiceInfo,
    };

    newClientId
      ? (body['clientId'] = newClientId)
      : (body['clientId'] = clientId);

    this.customerService.addUser(body).subscribe(
      (response) => {
        this.userService.patchUserMaxCount(response.id, 12).subscribe(
          (res) => {
            this.translate
              .get('customer.userAdded')
              .subscribe((text: string) => {
                this.toastr.success(text);
              });

            const sameClient = this.clientData.id === response.clientId;

            if (sameClient) {
              // Push if we add user to the same opened client, else don't push
              this.usersDataSearch.push(res);
              this.users.push(res);

              this.checkStatus(this.usersDataSearch);
              this.applyFilter();
            }
            this.dialogAddUser.close();
          },
          (err) => {
            this.translate
              .get('customer.tokenError')
              .subscribe((text: string) => {
                this.toastr.warning(text);
              });

            const sameClient = this.clientData.id === response.clientId;

            if (sameClient) {
              // Push if we add user to the same opened client, else don't push
              this.usersDataSearch.push(response);
              this.users.push(response);
              this.checkStatus(this.usersDataSearch);
              this.applyFilter();
            }
          }
        );
      },
      (error) => {
        this.toastr.error(error.message);
      }
    );
  }

  deleteUser(userId) {
    this.userService.deleteUser(userId).subscribe(
      (response) => {
        this.translate.get('customer.deletedUser').subscribe((text: string) => {
          this.toastr.success(text);
        });
        this.loadClient();

        const user = this.usersDataSearch.find((user) => user.id === userId);

        if (user !== undefined) {
          if (this.usersDataSearch.indexOf(user) != -1) {
            this.usersDataSearch.splice(this.usersDataSearch.indexOf(user), 1);
          }

          if (this.users.indexOf(user) != -1) {
            this.users.splice(this.users.indexOf(user), 1);
          }

          if (this.usersDataSearch.length < 1) {
            this.searchParam = '';
            this.applyFilter();
          }
        }
      },
      (error) => {
        this.toastr.error(error.message);
      }
    );
  }

  checkStatus(users: IUser[]) {
    this.util.checkStatus(users);
  }

  applyFilter() {
    this.getFilteredUsers();
    this.searchParam === ''
      ? this.changeQuery({
          searchParam: null,
          page: this.page === 1 ? null : this.page,
        })
      : this.changeQuery({
          searchParam: this.searchParam,
          clientId: this.clientID,
          page: this.page === 1 ? null : this.page,
        });
  }

  changeQuery(data) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: data,
      queryParamsHandling: 'merge',
    });
  }

  getFilteredUsers() {
    const filteredByOfflineStatus = this.users.filter(user => {
      if (!this.selectedFilter) {
        return true;
      }
      const currentDate = new Date();
      currentDate.setHours(23, 59, 59, 999); // Set the time to 00:00:00
      const offlineDuration = (currentDate.getTime() - new Date(user.lastTimeOnline).getTime()) / (1000 * 3600 * 24);
      return offlineDuration > this.selectedFilter;
    });

    this.usersDataSearch = filteredByOfflineStatus.filter(user =>
      user.name?.toLowerCase().includes(this.searchParam.toLowerCase()) ||
      user.email?.toLowerCase().includes(this.searchParam.toLowerCase())
    );
  }

  selectFilter(value: number | null): void {
    this.selectedFilter = value;
    this.getFilteredUsers();
  }

  navigateToUser(id: string) {
    let data;
    if (this.searchParam !== '') {
      data = { searchParam: this.searchParam };
    } else {
      data = null;
    }
    if (this.currentUser.role.name === Role.ROOT) {
      this.router.navigate(['root/users/' + id], {
        queryParams: data,
        queryParamsHandling: 'merge',
      });
    } else {
      this.router.navigate(['customer/users/' + id + '/profile'], {
        queryParams: data,
        queryParamsHandling: 'merge',
      });
    }
  }

  reloadUserData(res) {
    this.loadUsers();
  }

  jumpToPage(event: any) {
    if (event.srcElement && event.srcElement.localName == 'input') {
      const page = parseInt(event.target.value);
      const maxPage = Math.ceil(this.usersDataSearch.length / this.perPage);

      if (event.target.value == '' || page == this.page || page > maxPage) {
        return;
      }

      this.page = parseInt(event.target.value);
    } else {
      this.page = event;
    }
    this.sharedData.userPage = this.page;
    this.changeQuery({
      page: this.page === 1 ? null : this.page,
      clientId: this.clientID,
    });

    // this.page == 1 ? this.changeQuery({ 'page': null }) : this.changeQuery({ 'page': this.page });
  }

  clearUSerSearch() {
    if (this.searchParam !== '') {
      this.searchParam = '';
      this.applyFilter();
    }
  }

  trackByMethod(index: number, el: any): number {
    return el.id;
  }

  showUsersAfterReload() {
    this.loadClient();
    this.loadUsers();
    this.initializeBackgroundsAndPresets();
    this.loadClientSettings();
    this.loadLicensePlates();
    this.loadVehicleTypes();
    forkJoin({
      clientFeatures: this.loadClientFeaturesPrice(),
      features: this.loadAllFeatures(),
    }).subscribe((res) => {
      this.clientFeatures = res.clientFeatures;
      this.features = res.features;
    });
  }

  updateSetting(event, settingName: string) {
    let status = event.target.checked;
    this.updateClient(settingName, status);
  }

  handleSortUsers(data) {
    const sort = data.target.value;

    switch (sort) {
      case 'name':
        this.users = this.users.sort((a,b) => a.name?.localeCompare(b?.name));
        this.usersDataSearch = this.usersDataSearch.sort((a,b) => a.name?.localeCompare(b?.name));
        break;
      case 'lastOnline':
        this.users =  this.users.sort((a, b) => {
          return (new Date(b.lastTimeOnline) as any) - (new Date(a.lastTimeOnline) as any);
        });
        this.usersDataSearch = this.usersDataSearch.sort((a, b) => {
          return (new Date(b.lastTimeOnline) as any) - (new Date(a.lastTimeOnline) as any);
        });
        break;
      default:
        break;
    }
  }

  updateThreeSixtyVideoDuration() {
    const body = {
      threeSixtyVideoDuration:
        this.clientSettings.threeSixtyVideoDuration,
    };
    this.updateClientSettings(body);
  }
}
